import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/trading-calculator-contents/TopicOne";

const TradingCalculatorContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Your All-in-One Calculation Tool</h2>
                <p>
                  The Pips Trading Calculator is designed to help traders plan
                  every move with precision. From estimating profit and loss to
                  calculating required margin and pip value, our calculator
                  provides instant clarity, ensuring you trade with confidence,
                  not uncertainty. Whether you’re in Forex, Crypto, or Stocks,
                  The Pips equips you with the numbers that matter. It
                  simplifies complex calculations so you can focus on strategy
                  rather than manual computation. With accurate, real-time
                  results, you’re always prepared to make informed trading
                  decisions.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Start Calculating
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/trading_calculator/trading_calculator_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TradingCalculatorContentOne;
